import { Box, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getAllDrugBookmark } from "../../../../api/area";
import TableUserDrug from "./tableUserDrug";

export default function BookmarkDrugs({
  open,
  setOpen,
  areaId,
  //   rowData,
  //   setRowData,
  moduleId,
  setDataTable
}) {
  const [rowData, setRowData] = useState();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "13px",
    p: 4,
  };

  useEffect(() => {
    if (open) {
      getAllDrugBookmark(areaId)
        .then((x) => {
          setRowData(x);
        })
        .catch(() => {});
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography color="var(--emr-darkblue)" fontWeight={"bold"}>
          {"داوهای منتخب"}
        </Typography>
        {rowData?.length > 0 && (
          <TableUserDrug
            areaId={areaId}
            parvandeh
            setRowData={setRowData}
            rowData={rowData}
            moduleId={moduleId}
            bookmark
            setDataTable={setDataTable}
          />
        )}
      </Box>
    </Modal>
  );
}
